export const REGISTRY_INTERACTION = 'Registry Interaction';
export const REGISTRY_PAGE_VIEW = 'Registry Page View';
export const REGISTRY_VIEW = 'Registry View';
export const CASH_FUND_KYC_SUBMITTED = 'Cash Fund KYC Submitted';
export const CASH_FUND_KYC_SKIPPED = 'Cash Fund KYC Skipped';
export const CASH_FUND_TRANSFER_INITIATED = 'Cash Fund Transfer Initiated';
export const CASH_FUND_VERSION_V2 = 'V2';
export const SEGMENT_PAGE_CASH_FUND = 'cash funds';
export const SEGMENT_PRODUCT = 'your registry';
export const SEGMENT_PLATFORM = 'web';
export const SEGMENT_VIEW = 'view';

// Discover
export const DISCOVER_SOURCE = 'discover';
